module.exports = __webpack_public_path__ + "static/media/icon-check-white.ffa6a170.svg";